const UpArrowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M9 4.27772L5.66436 1.31271C5.28548 0.975926 4.71452 0.975926 4.33564 1.31271L1 4.27772"
        stroke="#5F606A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default UpArrowIcon;
